import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { RootState } from '../../../stores/store';

import './SideModal.scss';

interface Props extends LocalizeContextProps {
    isOpen: boolean;
    toggle: () => void;
    children?: React.ReactNode;
    headerText: string;
    objectRef: React.RefObject<HTMLDivElement>;
    footer: React.ReactNode;
    
}

class SideModal extends React.Component<Props> {
    public componentDidMount() {
        if (/Trident.*rv:/.test(navigator.userAgent)) {
            setTimeout(
                () => {
                    const modal = document.getElementById('side-modal')!
                        .parentElement!.parentElement!.parentElement;
                    if (modal) {
                        modal.style.display = 'none';
                        modal.style.display = '';
                        modal.style.zIndex = '';
                    }
                },
                500);
        }
    }

    public render() {
        const t = this.props.translate;
        return (
          <Modal
            id='side-modal'
            className='side-view'
            isOpen={this.props.isOpen}
            toggle={this.props.toggle}>
            <ModalHeader>{this.props.headerText}</ModalHeader>
            <ModalBody>
                <div ref={this.props.objectRef}>{this.props.children}</div>
            </ModalBody>
            <ModalFooter>{this.props.footer}</ModalFooter>
          </Modal>
        );
    }
}

const mapStateToProps = (state: RootState) => ({

});

export default connect(mapStateToProps)(withLocalize(SideModal));